import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
import { getGroupedByCountryStateOptionsByConfig } from '../../helpers/options';
// feature template report
import { itemSettings } from '../template/report/settings/item';
//////////////////////////////////////////////////

const additionalSettings = {
  [GC.GRC.CLO_LAST_EVENT_LATE_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-last-event', 'titles:late-date'],
  },
  [GC.GRC.CLO_PRIMARY_REF_VALUE]: {
    width: 250,
    name: ['titles:order', 'titles:primary-reference'],
  },
  [GC.GRC.CLO_FIRST_EVENT_LATE_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-first-event', 'titles:late-date'],
  },
  [GC.GRC.CLO_LAST_EVENT_EARLY_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-last-event', 'titles:early-date'],
  },
  [GC.GRC.CLO_FIRST_EVENT_EARLY_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-first-event', 'titles:early-date'],
  },
  [GC.GRC.CLO_LAST_EVENT_LOCATION_ZIP]: {
    width: 200,
    name: ['titles:clo-last-event', 'titles:zip'],
  },
  [GC.GRC.CLO_FIRST_EVENT_LOCATION_ZIP]: {
    width: 200,
    name: ['titles:clo-first-event', 'titles:zip'],
  },
  [GC.GRC.CLO_LAST_EVENT_LOCATION_CITY]: {
    width: 200,
    name: ['titles:clo-last-event', 'titles:city'],
  },
  [GC.GRC.CLO_FIRST_EVENT_LOCATION_CITY]: {
    width: 200,
    name: ['titles:clo-first-event', 'titles:city'],
  },
  [GC.GRC.CLO_LAST_EVENT_LOCATION_STATE]: {
    width: 200,
    fieldType: 'state',
    filterType: 'selectMultipleCreatable',
    name: ['titles:clo-last-event', 'titles:state'],
    options: getGroupedByCountryStateOptionsByConfig,
  },
  [GC.GRC.CLO_FIRST_EVENT_LOCATION_STATE]: {
    width: 200,
    fieldType: 'state',
    filterType: 'selectMultipleCreatable',
    options: getGroupedByCountryStateOptionsByConfig,
    name: ['titles:clo-first-event', 'titles:state'],
  },
  [GC.GRC.CLO_LAST_EVENT_LOCATION_COUNTRY]: {
    width: 200,
    name: ['titles:clo-last-event', 'titles:country'],
  },
  [GC.GRC.CLO_TELS_PRIMARY_REFERENCE_VALUE]: {
    width: 250,
    collection: true,
    name: ['titles:trips', 'titles:primary-reference'],
    customComponent: ({ fieldData }) => G.createStringFromArray(R.or(fieldData, []), ', '),
  },
  [GC.GRC.CLO_FIRST_EVENT_LOCATION_COUNTRY]: {
    width: 200,
    name: ['titles:clo-first-event', 'titles:country'],
  },
  [GC.GRC.CLO_LAST_EVENT_LOCATION_ADDRESS1]: {
    width: 200,
    name: ['titles:clo-last-event', 'titles:address1'],
  },
  [GC.GRC.CLO_FIRST_EVENT_LOCATION_ADDRESS1]: {
    width: 200,
    name: ['titles:clo-first-event', 'titles:address1'],
  },
  [GC.GRC.CLO_LAST_EVENT_APPOINTMENT_EARLY_DATE]: {
    width: 220,
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-last-event', 'titles:appointment-early-date'],
  },
  [GC.GRC.CLO_FIRST_EVENT_APPOINTMENT_EARLY_DATE]: {
    width: 220,
    fieldType: 'date',
    filterType: 'date',
    name: ['titles:clo-first-event', 'titles:appointment-early-date'],
  },
};

const settings = {
  ...R.omit([GC.FIELD_BRANCH_DOT_BRANCH_NAME], itemSettings),
  ...additionalSettings,
};

const getLocalizedName = (name) => {
  if (G.isArray(name)) return R.join(': ', R.map(G.getWindowLocale, name));

  return G.getWindowLocale(name, '...');
};

const getOptions = (options) => {
  if (G.isFunction(options)) return options();

  return options;
};

export const FILTER_PARAMS = R.values(R.mapObjIndexed(({
  name,
  options,
  sortable,
  collection,
  placeholder,
  disableFilter,
  filterType = 'string',
}, value) => ({
  value,
  collection,
  placeholder,
  disableFilter,
  [GC.FIELD_TYPE]: filterType,
  options: getOptions(options),
  disableSort: R.equals(sortable, false),
  [GC.FIELD_NAME]: getLocalizedName(name),
}), settings));

export const columnSettings = R.map(({
  fieldType,
  ...fieldSettings
}) => ({
  ...fieldSettings,
  [GC.FIELD_TYPE]: fieldType,
}), settings);

export const tableSettings = {
  minHeight: 320,
  cellFontSize: 13,
  titleFontSize: 12,
  titleRowHeight: 45,
  tableRowHeight: 40,
  allowEditBtn: true,
  useMainColors: true,
  checkBoxCellWidth: 0,
  moreBtnCellWidth: 50,
  allowSelectAll: false,
  expandableItems: false,
  searchableTitles: true,
  allowSelectItems: false,
  maxHeight: 'calc(100vh - 145px)',
};
